// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2026-02-04T11:44:26+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  191213
//    Project:        617
//    Environment:    7626 - master
//    MD5:            fc19f8218ee423d48502dad6c3ac2595
//    Signature:      eyJpdiI6Ikh1aWxzaEg1ZUE1ZkRlRTgzUWRVdEE9PSIsInZhbHVlIjoicVNsXC9FSXRucjZobndyUHliVGpZWEw2Nmp1RjEyXC8wZ0V6TGxzeDdZRXhCb2RXZmdKeHR1TlRpRXFITW1aY3NES0c3NWo3OUhxdzBrN1ZlczZQd3d3QXIraWhLaWFnTG5Oa3NSb0FqTUpMdG1cL1J3QnFnT0kxdFlLWGZVY09Nb3V6K1UrRFk2cUJ3T2RsTWNTSFNibGg2WFwvMVBheFVyRVwvQ2kzcVJzQzEydFh2Vm12SlZOc3c2eHZuMnBiUjVRVDFpaUtnU0NQQ29acE5UVUhzNGpcL1kxTDFlSVhZUUR2RXFEV081NkxcLzE4Um53bk8zTitVcXp1WXVlc0J1RFdENCtaOEl4aHlzZW1FYXd3dnJCV3I0dk9aeUNCUXBpN0RtUWs0aWdpdGN2dGFWWmpHTnJaQW9mM3kzYlN4dkFcL256NFI2QlEySG9EWmdkTG9Ld2JUUzlJaHRKbWU4cWtSTU1qQ295NHNuNVNnaDdJcVJSalVPVm1ob2o4dTRlWUwzYzJPaHMrdWFQM0JLMDVlNEdtaGxCbzNqbnZScElXbUt3MWRkdFpMa1pTS0YwPSIsIm1hYyI6IjkxOTI4OWI3ODcyY2MwOTAyNzQ2NTQ4OWExMGM5ZWFjYzA0NTUxOGVjYjcyNzQzYzZkNGQzYTcwMDhhNDdjYjAifQ==
const termsCheckbox = document.getElementById('terms');
const subscribeButton = document.getElementById('Subscribe');

if (termsCheckbox && subscribeButton) {
termsCheckbox.addEventListener('change', function() {
  subscribeButton.disabled = !this.checked;
});
}